angular.module('picmonicng').factory('LearnService', [
  '$q',
  '$filter',
  '$modal',
  '$interval',
  '$location',
  'UserService',
  'Picmonics',
  '$rootScope',
  '$window',
  'ngBowser',
  'TokenService',
  '$cacheFactory',
  'MetaService',
  'toaster',
  'WorkflowService',
  'PermissionsService',
  'PicmonicQueue',
  '$state',
  '$timeout',
  '$sce',
  'User',
  'hotkeys',
  'Upload',
  'SplitTestService',
  'QuizService',
  'ResourceUpgradeModalService',
  'SafetyModeModal',
  function (
    $q,
    $filter,
    $modal,
    $interval,
    $location,
    UserService,
    Picmonics,
    $rootScope,
    $window,
    ngBowser,
    TokenService,
    $cacheFactory,
    MetaService,
    toaster,
    WorkflowService,
    PermissionsService,
    PicmonicQueue,
    $state,
    $timeout,
    $sce,
    User,
    hotkeys,
    Upload,
    SplitTestService,
    QuizService,
    ResourceUpgradeModalService,
    SafetyModeModal
  ) {
    var defaults = {
      assetSize: 'md',

      audioMode: 'educational',

      backgroundVisible: true,

      distractors: [],

      rightSidebarOpen: false,

      rightSidebarExpanded: false,

      commentsOpen: false,

      notesOpen: true,

      mode: 'learn',

      insideQuiz: false,

      quizRoundId: null,

      shuffle: false,

      reviewStep: 1,

      quizStep: 1,

      modeStartTime: 0,

      factsAttempted: 0,

      quizAttempts: 0,

      quizIncorrect: false,

      factsCorrect: 0,

      learnComplete: 0,

      reviewComplete: 0,

      masterComplete: 0,

      totalTime: {
        learn: 0,
        review: 0,
        quiz: 0,
      },

      assetStatus: [],

      assetsLoaded: false,

      no_flash: false,

      zc: null,

      postBarEnabled: true,

      showPostBar: false,

      visiblePostBar: false,

      preLearnVisible: false,

      story_completed_flag: 0,

      education_completed_flag: 0,

      visibleInfoSegments: {
        references: true,
        keyFactsContent: true,
        educationalTranscript: false,
        storyTranscript: false,
        changeLog: false,
      },

      showBreadcrumbs: false,

      bothAudios: true,
    };

    var LearnService = {
      currentCard: {},

      factsOpen: false,

      currentFacts: [],

      communityFactGroups: [],

      currentCommunityFact: {},

      communityFactService: {
        mode: 'learn',
        assetStatus: [],
        assetsLoaded: false,
        getSlowSpeedMode: function () {
          return UserService.user.user_id
            ? typeof UserService.user.settings.slow_connection_mode != 'undefined'
              ? UserService.user.settings.slow_connection_mode
              : 0
            : 0;
        },
      },

      showCommunityFacts: true,

      currentFact: {},

      currentTime: 0,

      audioElement: null,

      endTime: 0,

      cardLoading: false,

      factsLoading: false,

      transitionOn: false,

      audioMuted: false,

      definitionVisible: true,

      modalInstance: null,

      relatedModalInstance: null,

      interval: null,

      fullscreen: false,

      theater: UserService.user.user_id
        ? typeof UserService.user.settings.learn_theater != 'undefined'
          ? UserService.user.settings.learn_theater
          : 0
        : $rootScope.embed
        ? 1
        : 0,

      quiz_mode: 0,

      queryStringParameters: $location.search(),

      assetSize: window.innerWidth > 768 ? '' : 'sm',

      quizResume: 0,

      startTime: 0,

      cardCache: $cacheFactory('cards', { capacity: 20 }),

      userUpdateTimeout: false,

      postLearnAction: function () {
        return UserService.user.user_id
          ? typeof UserService.user.settings.player_post_learn_action != 'undefined'
            ? UserService.user.settings.player_post_learn_action
            : 'switch_then_quiz'
          : 'switch_then_quiz';
      },

      postLearnActions: [
        { label: 'Switch Audio Then Quiz Picmonic', value: 'switch_then_quiz' },
        { label: 'Quiz Picmonic', value: 'quiz' },
        { label: 'Do Nothing', value: 'nothing' },
      ],

      getSlowSpeedMode: function () {
        return UserService.user.user_id
          ? typeof UserService.user.settings.slow_connection_mode != 'undefined'
            ? UserService.user.settings.slow_connection_mode
            : 0
          : 0;
      },

      startModeTimer: function (currentMode, newMode, sendingFactStats) {
        var self = this;
        var now = Math.round(new Date().getTime() / 1000);

        // If you've switch modes or we are preparing to send fact stats
        if (currentMode != newMode || sendingFactStats) {
          if (self.modeStartTime > 0) {
            self.totalTime[self.mode] += now - self.modeStartTime;
          }

          self.modeStartTime = now;
        }
      },

      setAudioSrc: function (element) {
        var self = this;

        return $q(function (resolve, reject) {
          self.currentCard.$promise.then(function () {
            if (self.audioMode === 'educational' && self.currentCard.audio['educational']) {
              if (element) {
                self.audioElement = element;
              }
              self.audioElement.src =
                window.pls_config.cdn_url +
                '/audio_classic' +
                (LearnService.getSlowSpeedMode() ? '_low' : '') +
                '/' +
                self.currentCard.audio['educational'];
            } else if (self.currentCard.audio['story']) {
              if (element) {
                self.audioElement = element;
              }
              self.audioElement.src =
                window.pls_config.cdn_url +
                '/audio_creative' +
                (LearnService.getSlowSpeedMode() ? '_low' : '') +
                '/' +
                self.currentCard.audio['story'];
            } else {
              self.audioElement = null;
            }

            if (self.audioElement) {
              //self.audioElement.oncanplay = function(){
              resolve();
              //};
            }
          });
        });
      },

      asyncAudioDownload: function () {
        var self = this;
        var nextAudio = document.createElement('audio');
        nextAudio.autoplay = false;
        nextAudio.preload = 'auto';

        self.currentCard.$promise.then(function () {
          if (self.audioMode == 'educational' && self.currentCard.audio['story']) {
            nextAudio.src =
              window.pls_config.cdn_url +
              '/audio_creative' +
              (LearnService.getSlowSpeedMode() ? '_low' : '') +
              '/' +
              self.currentCard.audio['story'];
          } else if (self.audioMode == 'story' && self.currentCard.audio['educational']) {
            nextAudio.src =
              window.pls_config.cdn_url +
              '/audio_classic' +
              (LearnService.getSlowSpeedMode() ? '_low' : '') +
              '/' +
              self.currentCard.audio['educational'];
          }
        });
      },

      showCommunityFactDisclaimerModal: function ($event) {
        $event.stopPropagation();
        $modal.open({
          templateUrl: '/templates/modals/community-fact-disclaimer.html',
          windowClass: 'community-fact-disclaimer-modal full-screen-modal',
          backdropClass: 'below-nav',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          controller: [
            '$scope',
            '$modalInstance',
            'UserService',
            function ($scope, $modalInstance, UserService) {
              $scope.agree = function () {
                if (!UserService.user.cf_terms_accepted) {
                  UserService.user.cf_terms_accepted = 1;
                  UserService.user.$update();
                }
                $modalInstance.close();
              };
            },
          ],
        });
      },

      showUpgradeModal: function (type) {
        if (this.audioElement && !this.audioElement.paused) {
          this.audioElement.pause();
        }

        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'learn_trial_upgrade_' + type);
        }

        ResourceUpgradeModalService.show(type);
      },

      showFactNoteModal: function (fact) {
        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'resources_add_note');
        }

        if (UserService.user.is_trial) {
          this.showUpgradeModal('resources');

          return;
        }

        $modal.open({
          templateUrl: '/templates/modals/fact-note.html',
          windowClass: 'pls-modal-fact-resources',
          backdropClass: 'below-nav',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          controller: [
            '$scope',
            'FactsResource',
            function ($scope, FactsResource) {
              $scope.loading = false;
              $scope.fact = fact;

              $scope.factNote = FactsResource.getv3({
                resource: 'notes',
                fact_id: fact.fact_id,
              });

              $scope.save = function () {
                if (!$scope.loading) {
                  $scope.loading = true;

                  FactsResource.savev3(
                    {
                      resource: 'notes',
                      fact_id: fact.fact_id,
                      note: $scope.factNote.note,
                    },
                    function (data) {
                      $scope.factNote = data;
                      fact.note = data.note;
                      $scope.$close();
                    }
                  ).$promise.finally(function () {
                    $scope.loading = false;
                  });
                }
              };
            },
          ],
        });
      },

      showFactResourcesModal: function (fact) {
        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'resources_add_image');
        }

        if (UserService.user.is_trial) {
          this.showUpgradeModal('resources');

          return;
        }

        $modal.open({
          templateUrl: '/templates/modals/fact-resources.html',
          windowClass: 'pls-modal-fact-resources',
          backdropClass: 'below-nav',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          controller: [
            '$scope',
            '$modalInstance',
            'LearnService',
            'hotkeys',
            'PermissionsService',
            'UserService',
            '$injector',
            function ($scope, $modalInstance, LearnService, hotkeys, PermissionsService, UserService, $injector) {
              $scope.LearnService = LearnService;
              $scope.UserService = UserService;
              $scope.fact = fact;
              $scope.$modalInstance = $modalInstance;
              $scope.PermissionsService = PermissionsService;
              $scope.options = {};
              PermissionsService.permissions.$promise.then(function () {
                if (!PermissionsService.hasAccess('admin', 'video_link').result) {
                  return false;
                }
                var adminFactsResource = $injector.get('adminFactsResource');
                $scope.suggested = adminFactsResource.suggest({
                  fact_id: fact.fact_id,
                });

                $scope.addResource = function (img) {
                  adminFactsResource
                    .duplicate({
                      fact_id: fact.fact_id,
                      resource_id: img.user_fact_resource_id,
                    })
                    .$promise.then(function (data) {
                      fact.resources.unshift(data);
                      toaster.success('Resource Added');
                    });
                };
              });

              hotkeys.bindTo($scope).add({
                combo: ['enter'],
                callback: function () {
                  LearnService.uploadFactResource(
                    $scope.file,
                    $scope.fact,
                    $scope.name,
                    $scope.source,
                    $scope.$modalInstance,
                    $scope.options.video_link,
                    $scope.private
                  );
                },
              });
            },
          ],
        });
      },

      showEditFactResourcesModal: function (fact, resource) {
        $modal.open({
          templateUrl: '/templates/modals/fact-resources-edit.html',
          windowClass: 'pls-modal-fact-resources',
          backdropClass: 'below-nav',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          controller: [
            '$scope',
            'LearnService',
            'hotkeys',
            'youtubeFactory',
            'FactsResource',
            function ($scope, LearnService, hotkeys, youtubeFactory, FactsResource) {
              $scope.LearnService = LearnService;
              $scope.fact = fact;
              $scope.resource = resource;

              $scope.save = function (video, fact, name, source) {
                $scope.uploadingResource = true;
                FactsResource.updatev3(
                  {
                    fact_id: $scope.fact.fact_id,
                    resource_id: resource.user_fact_resource_id,
                    resource: 'resources',
                    name: $scope.resource.name,
                    source: $scope.resource.source,
                  },
                  function (resp) {
                    $scope.$close();
                  },
                  function (resp) {
                    toaster.error(
                      'An error was encountered while uploading your resource. Try again, and if the problem persists, try another image.'
                    );
                    $scope.uploadingResource = false;
                    $scope.resourceUploadError = false;
                    $scope.$close();
                  }
                );
              };

              hotkeys.bindTo($scope).add({
                combo: ['enter'],
                callback: function () {
                  $scope.save();
                },
              });
            },
          ],
        });
      },

      showFactResourcesVideoModal: function (fact) {
        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'resources_add_video');
        }

        if (UserService.user.is_trial) {
          this.showUpgradeModal('resources');

          return;
        }

        $modal.open({
          templateUrl: '/templates/modals/fact-resources-video.html',
          windowClass: 'pls-modal-fact-resources',
          backdropClass: 'below-nav',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          controller: [
            '$scope',
            '$modalInstance',
            'LearnService',
            'hotkeys',
            'youtubeFactory',
            'FactsResource',
            function ($scope, $modalInstance, LearnService, hotkeys, youtubeFactory, FactsResource) {
              $scope.LearnService = LearnService;
              $scope.fact = fact;
              $scope.$modalInstance = $modalInstance;

              $scope.getVideo = function () {
                $scope.video = null;

                var videoId;
                var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                var match = $scope.source.match(regExp);
                if (match && match[2].length == 11) {
                  videoId = match[2];

                  youtubeFactory
                    .getVideoById({
                      videoId: videoId,
                      key: 'AIzaSyD3lOgBfFqnhEXnV5lPNPWFOagS_zYQiYE',
                    })
                    .then(function (response) {
                      if (response.data.items.length == 1) {
                        $scope.video = response.data.items[0];
                        $scope.name = $scope.video.snippet.title;

                        $scope.resourceUploadError = null;
                      } else {
                        $scope.resourceUploadError = 'Invalid YouTube Link';
                      }
                    })
                    .catch(function (response) {
                      $scope.resourceUploadError = 'Error getting video data';
                    });
                } else {
                  $scope.resourceUploadError = 'Invalid YouTube Link';
                }
              };

              $scope.saveVideo = function (video, fact, name, source) {
                if (!video) {
                  $scope.resourceUploadError = 'Invalid YouTube Link';
                  return;
                }
                $scope.uploadingResource = true;
                FactsResource.savev3(
                  {
                    fact_id: $scope.fact.fact_id,
                    resource: 'resources',
                    resource_type: 'video',
                    name: name,
                    source: source,
                    video: video,
                  },
                  function (resp) {
                    $scope.uploadingResource = false;
                    $scope.resourceUploadError = false;

                    fact.resources.unshift(resp);
                    $modalInstance.close();
                  },
                  function (resp) {
                    toaster.error(
                      'An error was encountered while uploading your resource. Try again, and if the problem persists, try another image.'
                    );
                    $scope.uploadingResource = false;
                    $scope.resourceUploadError = false;
                    $modalInstance.close();
                  }
                );
              };

              hotkeys.bindTo($scope).add({
                combo: ['enter'],
                callback: function () {
                  $scope.saveVideo();
                },
              });
            },
          ],
        });
      },

      showResourceGalleryModal: function (fact, resource) {
        var self = this;
        var resume = false;

        if (typeof atlasEvent !== 'undefined') {
          if (resource.is_mine) {
            atlasEvent('click', 'resources_personal');
          } else {
            atlasEvent('click', 'resources_community');
          }
        }

        if (self.audioElement) {
          if (!self.audioElement.paused) {
            self.audioElement.pause();
            resume = true;
          }
        }

        if (UserService.user.is_trial) {
          this.showUpgradeModal('resources');

          return;
        }

        if (
          $filter('filter')(fact.resources, { is_mine: '!1' }).length &&
          !UserService.user.has_seen.community_resources
        ) {
          UserService.see('community_resources');

          $modal.open({
            templateUrl: '/templates/modals/community-resources.html',
            windowClass: 'pls-modal-spaced-rep',
            size: 'md',
            backdropClass: 'above-nav',
            controller: [
              '$scope',
              'LearnService',
              function ($scope, LearnService) {
                $scope.go = function () {
                  LearnService.showResourceGalleryModal(fact, resource);
                };
              },
            ],
          });

          return;
        }

        var modal = $modal.open({
          templateUrl: '/templates/modals/resource-gallery.html',
          windowClass: 'pls-modal-resource-gallery full-screen-modal',
          backdropClass: 'above-nav',
          size: 'lg',
          controller: [
            '$scope',
            'LearnService',
            'FactsResource',
            'UserService',
            'hotkeys',
            '$modalInstance',
            function ($scope, LearnService, FactsResource, UserService, hotkeys, $modalInstance) {
              $scope.UserService = UserService;
              $scope.LearnService = LearnService;
              $scope.fact = fact;
              $scope.fact.selectedResourceIndex = $scope.fact.resources.indexOf(resource);

              $scope.showImage = function (resource) {
                if (typeof atlasEvent !== 'undefined') {
                  if (resource.is_mine) {
                    atlasEvent('click', 'resources_personal');
                  } else {
                    atlasEvent('click', 'resources_community');
                  }
                }

                $scope.fact.selectedResourceIndex = $scope.fact.resources.indexOf(resource);
              };

              $scope.upvote = function () {
                var vote = 1;
                if ($scope.fact.resources[$scope.fact.selectedResourceIndex].user_vote == 1) {
                  vote = 0;
                }

                $scope.fact.resources[$scope.fact.selectedResourceIndex].user_vote = vote;

                FactsResource.updatev3(
                  {
                    fact_id: $scope.fact.fact_id,
                    resource: 'resources',
                    resource_id: $scope.fact.resources[$scope.fact.selectedResourceIndex].user_fact_resource_id,
                    vote: vote,
                  },
                  function (data) {
                    $scope.fact.resources[$scope.fact.selectedResourceIndex].user_vote = data.vote;
                    $scope.fact.resources[$scope.fact.selectedResourceIndex].vote_total = data.vote_total;
                  }
                );
              };

              $scope.downvote = function () {
                var vote = -1;
                if ($scope.fact.resources[$scope.fact.selectedResourceIndex].user_vote == -1) {
                  vote = 0;
                }

                $scope.fact.resources[$scope.fact.selectedResourceIndex].user_vote = vote;

                FactsResource.updatev3(
                  {
                    fact_id: $scope.fact.fact_id,
                    resource: 'resources',
                    resource_id: $scope.fact.resources[$scope.fact.selectedResourceIndex].user_fact_resource_id,
                    vote: vote,
                  },
                  function (data) {
                    $scope.fact.resources[$scope.fact.selectedResourceIndex].user_vote = data.vote;
                    $scope.fact.resources[$scope.fact.selectedResourceIndex].vote_total = data.vote_total;
                  }
                );
              };

              $scope.next = function () {
                var resources = $scope.fact.resources;

                var currentPos = resources.indexOf($scope.fact.resources[$scope.fact.selectedResourceIndex]);
                if (currentPos < resources.length - 1) {
                  $scope.fact.selectedResourceIndex = $scope.fact.resources.indexOf(resources[currentPos + 1]);
                } else {
                  $scope.fact.selectedResourceIndex = $scope.fact.resources.indexOf(resources[0]);
                }
              };

              $scope.previous = function () {
                var resources = $scope.fact.resources;

                var currentPos = resources.indexOf($scope.fact.resources[$scope.fact.selectedResourceIndex]);
                if (currentPos == 0) {
                  $scope.fact.selectedResourceIndex = $scope.fact.resources.indexOf(resources[resources.length - 1]);
                } else {
                  $scope.fact.selectedResourceIndex = $scope.fact.resources.indexOf(resources[currentPos - 1]);
                }
              };

              $scope.report = function () {
                if (confirm('Are you sure you want to report this?')) {
                  FactsResource.updatev3(
                    {
                      fact_id: $scope.fact.fact_id,
                      resource: 'resources',
                      resource_id: $scope.fact.resources[$scope.fact.selectedResourceIndex].user_fact_resource_id,
                      report: true,
                    },
                    function (data) {
                      $scope.fact.resources.splice($scope.fact.selectedResourceIndex, 1);
                      $scope.fact.selectedResourceIndex = 0;

                      if ($scope.fact.resources.length == 0) {
                        $scope.$close();
                      }
                    }
                  );
                }
              };

              $scope.delete = function () {
                if (confirm('Are you sure you want to delete this resource?')) {
                  FactsResource.deletev3(
                    {
                      fact_id: $scope.fact.fact_id,
                      resource: 'resources',
                      resource_id: $scope.fact.resources[$scope.fact.selectedResourceIndex].user_fact_resource_id,
                    },
                    function (data) {
                      $scope.fact.resources.splice($scope.fact.selectedResourceIndex, 1);

                      var resources = $scope.fact.resources;

                      if (resources.length == 0) {
                        $modalInstance.close();
                      } else {
                        $scope.fact.selectedResourceIndex = $scope.fact.resources.indexOf(resources[0]);
                      }
                    }
                  );
                }
              };

              hotkeys
                .bindTo($scope)
                .add({
                  combo: ['right'],
                  callback: function () {
                    $scope.next();
                  },
                })
                .add({
                  combo: ['left'],
                  callback: function () {
                    $scope.previous();
                  },
                });
            },
          ],
        });

        modal.result.finally(function () {
          if (resume) {
            self.playAudio();
          }
        });
      },

      uploadFactResource: function (file, fact, name, source, $modalInstance, video_link, private) {
        var self = this;
        var resource_type = video_link ? 'video_link' : 'image';

        if (!file) {
          self.resourceUploadError = true;
          return;
        }
        self.uploadingResource = true;
        Upload.upload({
          url: '/api/v3/facts/' + fact.fact_id + '/resources',
          data: {
            file: file,
            name: name,
            source: source,
            resource_type: resource_type,
            private: private,
          },
        }).then(
          function (resp) {
            self.uploadingResource = false;
            self.resourceUploadError = false;

            fact.resources.unshift(resp.data);
            $modalInstance.close();
          },
          function (resp) {
            toaster.error(
              'An error was encountered while uploading your resource. Try again, and if the problem persists, try another image.'
            );
            self.uploadingResource = false;
            self.resourceUploadError = false;
            $modalInstance.close();
          }
        );
      },

      saveCardAttempt: function (cardReset) {
        var self = this;
        if (self.preLearnVisible) {
          return;
        }

        if (!UserService.user.user_id) {
          return;
        }

        if (!self.currentCard.is_owned) {
          return;
        }

        if (self.currentCard.in_workflow) {
          return;
        }

        self.startModeTimer(self.mode, self.mode, true);

        var nonHeaderFacts = $filter('filter')(self.currentFacts, {
          header: '!1',
        });

        var fact_stats = [];

        angular.forEach(nonHeaderFacts, function (value, key) {
          fact_stats.push({
            fact_id: value.fact_id,
            viewed: value.viewed,
            reviewed: value.reviewed,
          });
        });

        var learnComplete = self.learnComplete;
        var reviewComplete = self.reviewComplete;
        var masterComplete = self.masterComplete;

        self.learnComplete = 0;
        self.reviewComplete = 0;
        self.masterComplete = 0;

        return Picmonics.save(
          {
            card_id: self.currentCard.card_id,
            resource: 'attempts',
            mobile_flag: 0,
            mini_player_flag: 0,
            source_device: ngBowser.getPlatformType() || 'unknown',
            start_time: self.startTime,
            end_time: Math.round(new Date().getTime() / 1000),
            card_reset_flag: cardReset,
            facts_attempted: self.factsAttempted,
            facts_correct: self.factsCorrect,
            card_confidence: self.currentCard.rating,
            quiz_attempts: self.quizAttempts,
            fact_count: nonHeaderFacts.length,
            quiz_fact_stats: fact_stats,
            learn_time_spent: self.totalTime.learn,
            review_time_spent: self.totalTime.review,
            quiz_time_spent: self.totalTime.quiz,
            education_completed_flag: self.education_completed_flag,
            story_completed_flag: self.story_completed_flag,
            summary_viewed_flag: self.currentCard.summary_viewed_flag,
            playlist_id: PicmonicQueue.playlist_id,
            track_id: PicmonicQueue.track_id,
            learn_complete: learnComplete,
            review_complete: reviewComplete,
            master_complete: masterComplete,
            quiz_round_id: self.insideQuiz ? self.quizRoundId : null,
          },
          function () {
            if (!UserService.user.cards_viewed) {
              UserService.user.cards_viewed = 1;
            }
            // Notify interested components that the card data has changed
            $rootScope.$broadcast('cardDataChanged', {
              action: 'learn_attempt',
              card_id: self.currentCard.card_id,
            });
            self.factsAttempted = 0;
            self.factsCorrect = 0;
            self.quizAttempts = 0;
            self.totalTime.learn = 0;
            self.totalTime.review = 0;
            self.totalTime.quiz = 0;
            self.education_completed_flag = 0;
            self.story_completed_flag = 1;
            self.currentCard.summary_viewed_flag = 0;
            self.modeStartTime = 0;
          }
        );
      },

      toggleMute: function () {
        var self = this;

        self.audioMuted = !self.audioMuted;
        if (self.audioElement) {
          self.audioElement.muted = !self.audioElement.muted;
        }
      },

      toggleCommunityFacts: function () {
        var self = this;
        self.showCommunityFacts = !self.showCommunityFacts;

        if (self.showCommunityFacts) {
          angular.element('.player-sidebar-wrapper').animate(
            {
              scrollTop: angular.element('#community-fact-section')[0].offsetTop,
            },
            300
          );
        }
      },

      toggleShuffle: function () {
        var self = this;
        self.shuffle = !self.shuffle;
      },

      toggleExpandedSidebar: function () {
        var self = this;
        self.rightSidebarExpanded = !self.rightSidebarExpanded;
      },

      toggleComments: function () {
        var self = this;
        self.commentsOpen = true;
        self.notesOpen = false;
      },

      toggleNotes: function () {
        var self = this;
        self.notesOpen = true;
        self.commentsOpen = false;
      },

      closePostBar: function () {
        var self = this;
        angular.element('body').unbind('click.postbar');

        self.visiblePostBar = false;
        $timeout(function () {
          self.showPostBar = false;
        }, 1000);
      },

      /**
       * Set Audio Mode and Play
       *
       * Used in the mobile more menu audio selector to set the audio then start playing
       * @param mode
       */
      setAudioModeAndPlay: function (mode) {
        var self = this;

        if (self.interval) {
          $interval.cancel(self.interval);
        }

        self.audioMode = mode;
        self.clearSelectedFact();

        self.setAudioSrc().then(function () {
          self.playAudio();

          // Close the pre-learn modal
          self.closePostBar();

          send_ga('event', 'Learn', 'Audio Switched');
        });
      },

      /**
       * Toggle Audio Mode
       *
       * Used by the educational/story buttons in the learn player to switch the audio and the restart learn function
       */
      toggleAudioMode: function () {
        var self = this;
        self.audioElement && self.audioElement.pause();
        if (self.audioMode === 'educational') {
          self.setAudioModeAndPlay('story');
        } else {
          self.setAudioModeAndPlay('educational');
        }
      },

      toggleDefinitionVisibility: function () {
        var self = this;
        self.definitionVisible = !self.definitionVisible;

        UserService.user.tooltip_def_expanded = self.definitionVisible ? 1 : 0;
        if (UserService.user.user_id) {
          UserService.user.$update();
        }
      },

      seek: function (time) {
        var self = this;
        if (self.audioElement) {
          self.audioElement.currentTime = time;
        }
        self.currentTime = time;
      },

      playOrRestart: function ($event) {
        var self = this;
        if (self.audioElement && self.audioElement.ended) {
          self.restartLearn(true);
        } else {
          self.playPauseAudio($event);
        }
      },

      playPauseAudio: function () {
        var self = this;
        self.player_mode = 'learn';

        if (self.audioElement) {
          if (self.audioElement.paused) {
            self.playAudio();
          } else {
            var p = self.audioElement.pause();
            p && p.catch && p.catch(function (e) {});
            // Open the sidebar
            if (UserService.user.facts_open && UserService.user.hide_facts_during_audio) {
              self.factsOpen = true;
            } else if (!UserService.user.facts_open) {
              self.factsOpen = false;
            }
          }
        }
      },

      playAudio: function () {
        var self = this;

        if (self.currentCard.is_owned) {
          self.learnComplete = false;
          if (self.audioElement) {
            var p = self.audioElement.play();
            p && p.catch && p.catch(function (e) {});

            // Close the sidebar
            if (!UserService.user.facts_open || UserService.user.hide_facts_during_audio) {
              self.factsOpen = false;
            }
          }
        }
      },

      stopIfPaused: function () {
        var self = this;
        if (self.audioElement && self.audioElement.paused) {
          self.seek(0);
          self.clearSelectedFact();
        } else if (!self.audioElement) {
          self.clearSelectedFact();
        }
      },

      playFactAudio: function (fact) {
        var self = this;
        if (self.audioElement) {
          if (self.audioElement.paused) {
            if (self.currentFact != fact || self.audioElement.currentTime >= fact.audio[self.audioMode].end - 0.5) {
              self.seek(fact.audio[self.audioMode].start);
            }
            self.endTime = fact.audio[self.audioMode].end;

            if (LearnService.audioElement) {
              LearnService.audioElement.play();
            }
          } else {
            self.audioElement.pause();
          }
        }
      },

      toggleFactBar: function () {
        var self = this;
        self.factsOpen = !self.factsOpen;
        if (self.factsOpen) {
          send_ga('event', 'Learn', 'Factlist Opened');
        } else {
          send_ga('event', 'Learn', 'Factlist Closed');
        }
        UserService.user.facts_open = self.factsOpen;
        if (UserService.user.user_id) {
          UserService.user.$update();
        }
      },

      toggleRightSidebar: function () {
        var self = this;
        self.rightSidebarOpen = !self.rightSidebarOpen;
      },

      goToCard: function (slug) {
        var self = this;
        $location.path('/learn/' + slug);
      },

      getCard: function (slug, setViewed, loadAssets) {
        var self = this;
        var resolvedData = {};

        return (self.loadingPromise = $q(function (resolve, reject) {
          if (!setViewed) {
            var card = self.cardCache.get(slug);
            if (card) {
              resolve(card);
              return;
            }
          }

          resolvedData.currentCard = Picmonics.get(
            { slug: slug, setViewed: setViewed },
            function () {},
            function (error) {
              reject(error);
            }
          );

          resolvedData.currentCard.$promise.then(function () {
            function loadAsset(url) {
              return $q(function (resolve, reject) {
                var img = new Image();
                img.addEventListener('load', function () {
                  resolve();
                });

                img.addEventListener('error', function (e) {
                  reject();
                });
                img.src = LearnService.getSlowSpeedMode()
                  ? url.replace('picmonic_assets', 'picmonic_assets_quarter')
                  : url.replace('picmonic_assets', 'picmonic_assets_threequarter');
              });
            }

            if (loadAssets) {
              var images = [];
              if (resolvedData.currentCard.background_image_url) {
                images.push(loadAsset(resolvedData.currentCard.background_image_url));
              }
              var x, y, z;
              for (x in resolvedData.currentCard.facts) {
                for (y in resolvedData.currentCard.facts[x].characters) {
                  for (z in resolvedData.currentCard.facts[x].characters[y].assets) {
                    images.push(loadAsset(resolvedData.currentCard.facts[x].characters[y].assets[z].image_url));
                  }
                }
              }
              for (y in resolvedData.currentCard.characters) {
                for (z in resolvedData.currentCard.characters[y].assets) {
                  images.push(loadAsset(resolvedData.currentCard.characters[y].assets[z].image_url));
                }
              }

              console.time('assets');
              window.assets_start = new Date().getTime();
              $q.all(images).finally(function () {
                console.timeEnd('assets');

                window.assets_end = new Date().getTime();
                if (
                  UserService.user.user_id &&
                  window.assets_end - window.assets_start > 7000 &&
                  UserService.user.has_seen &&
                  !UserService.user.has_seen.learn_slow_speed_onboarding
                ) {
                  LearnService.showSlowSpeedOnboarding();
                }

                resolve(resolvedData);
              });
            }

            self.bothAudios =
              resolvedData.currentCard.audio.educational && resolvedData.currentCard.audio.story ? true : false;

            var facts = angular.copy(resolvedData.currentCard.facts);
            facts = $filter('orderBy')(facts, ['-is_primary', 'order', 'fact_id']);

            var count = 0,
              a;

            for (a in facts) {
              if (!facts[a].header && facts[a].entity_type_id == 2) {
                facts[a].display_order = count;
                facts[a].shuffle_order = Math.random();
                count++;
              }
            }

            resolvedData.currentFacts = facts;

            if (resolvedData.currentCard.in_workflow) {
              WorkflowService.getPicmonicWorkflow(resolvedData.currentCard.card_id);
            } else {
              self.cardCache.put(slug, resolvedData);
            }

            if (!loadAssets) {
              resolve(resolvedData);
            }
          });
        }));
      },

      preloadNextPrevCard: function () {
        var self = this;
        var next = PicmonicQueue.next(true),
          previous = PicmonicQueue.previous(true);
        var sizeSuffix = LearnService.getSlowSpeedMode() ? '_quarter' : '_threequarter';

        if (next) {
          LearnService.getCard(next.slug).then(function (data) {
            var x, y;
            if (data.currentCard.background_image_url) {
              var bg = new Image();
              bg.src = data.currentCard.background_image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix);
            }

            for (y in data.currentCard.characters) {
              angular.forEach(data.currentCard.characters[y].assets, function (value, key) {
                var img = new Image();
                img.src = value.image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix);
              });
            }

            for (x in data.currentFacts) {
              for (y in data.currentFacts[x].characters) {
                angular.forEach(data.currentFacts[x].characters[y].assets, function (value, key) {
                  var img = new Image();
                  img.src = value.image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix);
                });
              }
            }
          });
        }

        if (previous) {
          LearnService.getCard(previous.slug).then(function (data) {
            var x, y;
            if (data.currentCard.background_image_url) {
              var bg = new Image();
              bg.src = data.currentCard.background_image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix);
            }

            for (y in data.currentCard.characters) {
              angular.forEach(data.currentCard.characters[y].assets, function (value, key) {
                var img = new Image();
                img.src = value.image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix);
              });
            }

            for (x in data.currentFacts) {
              for (y in data.currentFacts[x].characters) {
                angular.forEach(data.currentFacts[x].characters[y].assets, function (value, key) {
                  var img = new Image();
                  img.src = value.image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix);
                });
              }
            }
          });
        }
      },

      clearCardCache: function () {
        var self = this;

        self.cardCache.removeAll();
      },

      startCard: function () {
        var self = this;

        if (!self.currentCard.has_characters) {
          self.assetsLoaded = true;
        }

        if (self.currentCard.in_workflow) {
          self.dismissPrelearnModal();
        }

        if ($rootScope.embed && (self.currentCard.is_owned || TokenService.values.tokens)) {
          self.dismissPrelearnModal(true);
          UserService.user.audio_speed = 1;
        }

        if (
          UserService.user.user_id &&
          (!UserService.user.show_prelearn_modal ||
            self.currentCard.entity_type_id == 1 ||
            ($rootScope.embed && (self.currentCard.is_owned || TokenService.values.tokens)))
        ) {
          self.dismissPrelearnModal().then(function () {
            // UGC Warning Modal
            if (
              self.currentCard.entity_type_id === 1 &&
              self.currentCard.entity_id !== UserService.user.user_id //&&
              //!UserService.user.ugc_modal_seen
            ) {
              self.showUGCWarningModal();
            }
          });
        }

        if ($location.search().nomodal) {
          self.dismissPrelearnModal().then(function () {
            self.closeModal();
            $state.go('.', { nomodal: null });
          });
        }

        self.transitionOn = true;
        self.startTime = Math.round(new Date().getTime() / 1000);
        self.startModeTimer('', 'learn');
        self.startLearn();

        if (UserService.user.tooltip_def_expanded == 0) {
          self.definitionVisible = false;
        }
      },

      selectFact: function (fact) {
        var self = this;

        angular.forEach(self.communityFactGroups, function (value, key) {
          angular.forEach(value.facts, function (value2, key2) {
            value2.selected = false;
          });
        });
        self.currentCommunityFact = {};

        if (self.mode == 'review') {
          self.reviewStep = 1;
        } else if (self.mode == 'quiz') {
          self.quizStep = 1;
        }

        var selected = self.currentFacts[$filter('arrayPos')(self.currentFacts, true, 'selected')];

        if (selected) {
          selected.selected = false;
        }

        fact.selected = true;

        if (self.mode == 'learn') {
          fact.learned_flag = 1;
          fact.viewed = 1;
          fact.learnIncomplete = 0;
        } else if (self.mode == 'review') {
          fact.reviewed = 1;
        }

        self.currentFact = fact;
      },

      clearSelectedFact: function () {
        var self = this;

        self.currentFact = {};
        var selected = self.currentFacts[$filter('arrayPos')(self.currentFacts, true, 'selected')];
        if (selected) {
          selected.selected = false;
        }
      },

      resetSessionFactStats: function () {
        var self = this;
        var facts = $filter('filter')(self.currentFacts, { header: '!1' });

        for (var a in facts) {
          facts[a].learnIncomplete = 1;
          facts[a].reviewIncomplete = 1;
          facts[a].quizIncomplete = 1;
        }
      },

      hasNextFact: function () {
        var self = this;

        var picmonicFacts = $filter('filter')(self.currentFacts, {
          entity_type_id: '2',
          header: '!1',
        });

        if (!picmonicFacts || !picmonicFacts.length) {
          return false;
        }

        var currentFactPosition = $filter('arrayPos')(picmonicFacts, self.currentFact.fact_id, 'fact_id');
        var lastFactPosition = picmonicFacts.length - 1;

        // We're on the last fact
        if (currentFactPosition === lastFactPosition) {
          return false;
        }

        // Sometimes near the end if it's playing and there isn't a fact selected because it's just reviewing it
        if (self.audioElement && !self.audioElement.paused && self.currentFact && !self.currentFact.fact_id) {
          return false;
        }

        return true;
      },

      nextFactStep: function () {
        var self = this;

        if (self.mode == 'learn') {
          self.nextFact();
        } else {
          if (self.currentFact.fact_id && self[self.mode + 'Step'] == 1) {
            self[self.mode + 'Step'] = 2;
            $rootScope.$broadcast('learnStepChange');
          } else {
            self.nextFact();
          }
        }
      },

      nextFactButton: function () {
        var self = this;

        self.nextFact();
        if (
          self.currentFact.fact_id &&
          self.currentFact.entity_type_id == 2 &&
          self.currentCard.audio[self.audioMode]
        ) {
          self.seek(self.currentFact.audio[self.audioMode].start + 0.5);
        }

        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'Player - Next Fact');
        }
      },

      hasPreviousFact: function () {
        var self = this;

        // Has Audio
        if (this.audioElement && this.audioElement.currentTime < 1) {
          return false;
        }

        // No Audio
        if (!self.currentCard.audio || !self.currentCard.audio['educational']) {
          var picmonicFacts = $filter('filter')(self.currentFacts, {
            entity_type_id: '2',
            header: '!1',
          });

          // No Facts
          if (!picmonicFacts || !picmonicFacts.length) {
            return false;
          }

          var currentFactPosition = $filter('arrayPos')(picmonicFacts, self.currentFact.fact_id, 'fact_id');

          // No fact selected
          if (currentFactPosition === null) {
            return false;
          }

          // If you're on the first fact
          if (currentFactPosition === 0) {
            return false;
          }
        }

        return true;
      },

      previousFactButton: function () {
        var self = this;

        if (self.audioElement) {
          self.seek(self.audioElement.currentTime - 1.5);
        } else {
          return self.previousFact();
        }

        self.determineFact();
        if (!self.currentFact.fact_id) {
          var facts = $filter('filter')($filter('orderBy')(LearnService.currentFacts, '-order'), {
            header: '!1',
            entity_type_id: '!1',
          });
          self.selectFact(facts[0]);
        }

        if (
          self.currentFact.fact_id &&
          self.currentFact.entity_type_id == 2 &&
          self.currentCard.audio[self.audioMode]
        ) {
          self.seek(self.currentFact.audio[self.audioMode].start + 0.5);
        }

        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'Player - Previous Fact');
        }
      },

      determineFact: function () {
        var self = this;
        var currentFact;
        var facts = $filter('filter')($filter('orderBy')(LearnService.currentFacts, 'order'), {
          header: '!1',
          entity_type_id: '!1',
        });

        for (a in facts) {
          var fact = facts[a];

          if (fact.audio[LearnService.audioMode]) {
            if (
              LearnService.audioElement &&
              LearnService.audioElement.currentTime >= fact.audio[LearnService.audioMode].start &&
              LearnService.audioElement.currentTime <= fact.audio[LearnService.audioMode].end + 0.5
            ) {
              currentFact = fact;
              if (currentFact == LearnService.currentFact) {
                if (
                  LearnService.audioElement.currentTime < currentFact.audio[LearnService.audioMode].end - 0.5 &&
                  LearnService.audioElement.currentTime > currentFact.audio[LearnService.audioMode].start + 0.5 &&
                  LearnService.audioElement.currentTime - currentFact.audio[LearnService.audioMode].start < 5
                ) {
                  LearnService.currentFact.zoom = true;
                } else {
                  LearnService.currentFact.zoom = false;
                }
                return;
              }
            }
          }
        }

        if (currentFact) {
          if (
            LearnService.audioElement.currentTime < currentFact.audio[LearnService.audioMode].end - 0.5 &&
            LearnService.audioElement.currentTime > currentFact.audio[LearnService.audioMode].start + 0.5 &&
            LearnService.audioElement.currentTime - currentFact.audio[LearnService.audioMode].start < 5
          ) {
            LearnService.currentFact.zoom = true;
          } else {
            LearnService.currentFact.zoom = false;
          }

          if (currentFact != LearnService.currentFact) {
            LearnService.selectFact(currentFact);
          }
        } else {
          LearnService.clearSelectedFact();
        }
      },

      nextFact: function () {
        var self = this;
        var next,
          unseen = [];

        var facts = $filter('filter')(self.currentFacts, { header: '!1' });

        if (self.mode == 'learn') {
          if (!$filter('filter')(facts, { learned_flag: '!1' }).length && self.currentCard.learned_flag != 1) {
            self.endStep();
            return;
          }

          unseen = $filter('filter')(facts, { learnIncomplete: '1' });
        } else if (self.mode == 'review') {
          unseen = $filter('filter')(facts, { reviewIncomplete: '1' });
        } else if (self.mode == 'quiz') {
          unseen = $filter('filter')(facts, { quizIncomplete: '1' });

          if (self.quizIncorrect) {
            facts = $filter('filter')(facts, {
              last_answer: '!1',
              quizIncomplete: '1',
            });

            if (
              facts.length &&
              self.currentFact.fact_id &&
              $filter('arrayPos')(facts, self.currentFact.fact_id, 'fact_id') == null
            ) {
              facts.push(self.currentFact);
            }
          }
        }

        if (self.shuffle && self.mode == 'review') {
          facts = $filter('orderBy')(facts, 'shuffle_order');
          unseen = $filter('orderBy')(unseen, 'shuffle_order');
        } else {
          facts = $filter('orderBy')(facts, ['-is_primary', 'entity_id', 'order']);
          unseen = $filter('orderBy')(unseen, ['-is_primary', 'entity_id', 'order']);
        }

        if (self.currentFact.fact_id) {
          var factpos = $filter('arrayPos')(facts, self.currentFact.fact_id, 'fact_id');

          if (factpos != facts.length - 1) {
            next = facts[factpos + 1];
          } else if (self.mode == 'review') {
            next = null;
          } else {
            next = facts[0];
          }
        } else {
          next = facts[0];
        }

        if (next) {
          self.selectFact(next);

          if (self.mode == 'review') {
            if (self.audioElement) {
              self.audioElement.pause();
            }

            if (next.audio[self.audioMode]) {
              self.seek(next.audio[self.audioMode].start);
              self.endTime = next.audio[self.audioMode].end;
            }
          }
        } else {
          self.endStep();
        }
      },

      previousFact: function () {
        var self = this;
        var next;

        var facts = $filter('filter')(self.currentFacts, { header: '!1' });

        if (self.mode == 'quiz') {
          if (self.quizIncorrect) {
            facts = $filter('filter')(facts, {
              last_answer: '!1',
              quizIncomplete: '1',
            });

            if (
              facts.length &&
              self.currentFact.fact_id &&
              $filter('arrayPos')(facts, self.currentFact.fact_id, 'fact_id') == null
            ) {
              facts.push(self.currentFact);
            }
          }
        }

        if (self.shuffle && (self.mode == 'review' || self.mode == 'quiz')) {
          facts = $filter('orderBy')(facts, 'shuffle_order');
        } else {
          facts = $filter('orderBy')(facts, ['-is_primary', 'entity_id', 'order']);
        }

        if (self.currentFact.fact_id) {
          var factpos = $filter('arrayPos')(facts, self.currentFact.fact_id, 'fact_id');
          if (factpos == 0) {
            next = facts[facts.length - 1];
          } else {
            next = facts[factpos - 1];
          }
        } else {
          next = facts[facts.length - 1];
        }

        if (next) {
          self.selectFact(next);

          if (self.mode == 'review') {
            if (self.audioElement) {
              self.audioElement.pause();
            }

            if (next.audio[self.audioMode]) {
              self.seek(next.audio[self.audioMode].start);
              self.endTime = next.audio[self.audioMode].end;
            }
          }
        } else {
          self.endStep();
        }
      },

      changeVolume: function (level) {
        var self = this;
        self.audioMuted = false;

        self.setVolume(level);
        UserService.user.$update();
      },

      setVolume: function (level) {
        var self = this;

        if (!level) {
          level = 1;
        }

        if (level > 1) {
          level = 1;
        } else if (level < 0) {
          level = 0;
        }

        if (self.audioElement) {
          self.audioElement.muted = self.audioMuted;
          self.audioElement.volume = level;
        }

        if (UserService.user.audio_volume != level) {
          UserService.user.audio_volume = level;
          if (UserService.user.user_id) {
            UserService.user.$update();
          }
        }
      },

      setAudioSpeed: function (speed) {
        var self = this;
        self.audioElement.playbackRate = speed;
        UserService.user.audio_speed = speed;
        if (UserService.user.user_id) {
          UserService.user.$update();
        }
        angular.element('.audio-speed.btn-group .dropdown-toggle').focus();
        send_ga('event', 'Learn', 'Speed Changed');
      },

      startLearn: function () {
        var self = this;
        self.closePostBar();

        if (QuizService.quizInProgress && self.quiz) {
          QuizService.endQuiz();
          self.insideQuiz = false;
        }
        self.quiz = false;
        self.player_mode = 'learn';
        self.theater = UserService.user.user_id
          ? typeof UserService.user.settings.learn_theater != 'undefined'
            ? UserService.user.settings.learn_theater
            : 0
          : $rootScope.embed
          ? 1
          : 0;
        if (!self.currentCard.is_owned) {
          LearnService.showPreLearnModal();
          return;
        }

        self.startModeTimer(self.mode, 'learn');
        self.mode = 'learn';
        self.learnComplete = false;
        self.rightSidebarOpen = false;
        if (self.audioElement) {
          self.factsOpen = UserService.user.facts_open;
          self.audioElement.pause();
          self.seek(0);
        }
        self.clearSelectedFact();
        self.resetSessionFactStats();
        self.endTime = 0;

        if (self.queryStringParameters.toggleNotes) {
          self.toggleRightSidebar();
        }

        send_ga('event', 'Learn', 'Switched To Learn');
      },

      restartLearn: function (playSameAudio) {
        var self = this;

        if (self.quiz && !QuizService.quizComplete) {
          self.seek(0);
          self.audioElement.play();
          return;
        }

        if (!playSameAudio) {
          self.toggleAudioMode();
        }
        self.closePostBar();
        self.startLearn();
        if (self.audioElement) {
          self.audioElement.play();

          // Focus play/pause button (ADA)
          $timeout(function () {
            angular.element('#audio-toggle-control').focus();
          });
        }
      },

      clickQuizTab: function () {
        var self = this;

        if (!self.quiz) {
          self.startQuiz();
        }
      },

      startQuiz: function () {
        var self = this;
        if (LearnService.preLearnVisible) {
          return;
        }
        if (
          UserService.user.is_trial &&
          TokenService.values.quiz_questions < 1 &&
          !LearnService.currentCard.is_free &&
          !LearnService.currentCard.is_owned
        ) {
          PicmonicQueue.goToQuiz(self.currentCard.slug);
          return;
        }
        self.saveCardAttempt(0);
        self.quiz = true;
        self.player_mode = 'quiz';
        self.theater = 1;
        self.factsOpen = 0;
        self.mode = 'learn';
        self.learnComplete = false;
        if (self.audioElement) {
          self.audioElement.pause();
          self.seek(0);
        }
        self.clearSelectedFact();
        self.resetSessionFactStats();
        self.endTime = 0;

        self.insideQuiz = true;

        QuizService.startQuiz(true);
      },

      startReview: function () {
        var self = this;

        if (self.currentCard.is_owned === 0) {
          return;
        }

        self.quiz = false;
        self.player_mode = 'learn';
        self.theater = UserService.user.user_id
          ? typeof UserService.user.settings.learn_theater != 'undefined'
            ? UserService.user.settings.learn_theater
            : 0
          : 0;
        if (QuizService.quizInProgress) {
          QuizService.endQuiz();
        }

        self.closePostBar();
        if (self.preLearnVisible) {
          self.dismissPrelearnModal();
        }

        self.startModeTimer(self.mode, 'review');
        self.mode = 'review';
        if (window.innerWidth > 768) {
          self.factsOpen = false;
        }
        self.rightSidebarOpen = false;

        if (self.audioElement) {
          self.audioElement.pause();
          self.seek(0);
        }
        self.clearSelectedFact();
        self.resetSessionFactStats();
        self.endTime = 0;

        send_ga('event', 'Learn', 'Switched To Review');
      },

      endStep: function (audioFlag) {
        var self = this;

        if ($rootScope.bodyClass.indexOf('playing') !== -1) {
          $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('playing'), 1);
        }

        self.clearSelectedFact();

        if (audioFlag || self.mode == 'review') {
          if (self.shouldShowPostBar()) {
            self.showPostBar = true;
            self.visiblePostBar = true;
          }
        }

        if (self.audioElement) {
          self.audioElement.pause();
        }

        if (self.mode == 'learn') {
          // Open facts on audio end
          if (self.audioElement) {
            if (!LearnService.factsOpen && UserService.user.facts_open && UserService.user.hide_facts_during_audio) {
              LearnService.factsOpen = true;
            }
          }

          self.learnComplete = 1;
          var notlearned = $filter('filter')(self.currentFacts, {
            learned_flag: '!1',
            header: '!1',
          }).length;

          if (notlearned === 0 && self.currentCard.learned_flag != 1) {
            self.clearSelectedFact();

            if (self.shouldShowPostBar()) {
              self.showPostBar = true;
              self.visiblePostBar = true;
            } else if (
              (self.currentCard.entity_type_id === 1 && self.currentCard.entity_id !== UserService.user.user_id) ||
              (self.currentCard.entity_type_id === 2 && self.currentCard.entity_id !== 1)
            ) {
              self.showReviewModal();
            }

            self.currentCard.learned_flag = 1;
            if (UserService.user.user_id) {
              self.currentCard.$update().then(function () {
                $rootScope.$broadcast('cardDataChanged', {
                  action: 'learn_complete',
                  card_id: self.currentCard.card_id,
                });
              });
            }
          }
        } else {
          self.reviewComplete = 1;
        }
      },

      shouldShowPostBar: function () {
        var self = this;

        // ugc / no post learn action
        if (
          self.currentCard.entity_type_id === 1 ||
          (self.currentCard.entity_type_id === 2 &&
            self.currentCard.entity_id !== 1 &&
            self.currentCard.entity_id !== 379405 &&
            self.currentCard.card_id < 50000) ||
          self.postLearnAction() === 'nothing' ||
          self.postBarEnabled === false ||
          self.quiz
        ) {
          return false;
        }

        // trial member with no quiz questions left
        if (UserService.user.is_trial && TokenService.values.quiz_questions < 1) {
          // next action is quiz
          if (
            self.postLearnAction() === 'quiz' ||
            (self.postLearnAction() === 'switch_then_quiz' &&
              !(self.audioMode === 'educational' && self.currentCard.audio.story && self.currentCard.audio.educational))
          ) {
            return false;
          }
        }

        return true;
      },

      share: function (method, failed) {
        var self = this;

        if (typeof atlasEvent !== 'undefined' && method != 'facebook') {
          atlasEvent('share', 'learn - ' + method);
        }

        if (method == 'copy') {
          if (failed) {
            // Pop modal
            $modal.open({
              templateUrl: '/templates/modals/share-copy.html',
              windowClass: 'below-nav learn-light-modal',
              backdropClass: 'below-nav',
              backdrop: 'true',
              keyboard: false,
              size: 'md',
              controller: [
                '$scope',
                '$modalInstance',
                '$timeout',
                function ($scope, $modalInstance, $timeout) {
                  $timeout(function () {
                    var input = $('#copy-modal-url');
                    input.focus();
                    input.select();
                  }, 0);

                  $scope.close = function () {
                    $modalInstance.close();
                  };

                  $scope.picmonic_url = window.location.href.replace('learn', 'share/picmonic');
                },
              ],
            });
          } else {
            toaster.success('Copied', 'URL has been copied to the clipboard.');
          }
        } else {
          var title = self.currentCard.name;
          if (self.currentCard.entity_type_id == 1) {
            title = self.currentCard.name + ' - Created By: ' + UserService.user.username;
          }

          var url = $location.absUrl().replace('learn', 'share/picmonic');
          var target = 'Picmonic';
          self.showSharingWidget(method, target, url, title);
        }
      },

      showSharingWidget: function (method, target, url, title) {
        send_ga('event', target, 'Shared on: ' + method);

        switch (method) {
          case 'twitter':
            var left =
              window.outerWidth / 2 - 300 + (window.screenLeft !== undefined ? window.screenLeft : screen.left);
            var top = window.outerHeight / 2 - 200 + (window.screenTop !== undefined ? window.screenTop : screen.top);
            url = encodeURIComponent(
              url +
                '?utm_source=twitter&utm_medium=social&utm_term=1463760115&utm_content=image_link&utm_campaign=player_share_tw&' +
                UserService.getReferralParam()
            );

            window.open(
              'https://twitter.com/share?url=' + url + '&text=' + title,
              'twitter',
              'height=400,width=600,left=' +
                left +
                ',top=' +
                top +
                ',location=no,resizable=no,scrollbars=no,status=no,toolbar=no,titlebar=no'
            );
            break;
          case 'facebook':
            FB.ui(
              {
                method: 'share',
                display: 'popup',
                href:
                  url +
                  '?utm_source=facebook&utm_medium=social&utm_term=1463760054&utm_content=image_link&utm_campaign=player_share_fb&' +
                  UserService.getReferralParam(),
              },
              function (response) {
                if (response && !response.error_message) {
                  if (typeof atlasEvent !== 'undefined') {
                    atlasEvent('share', 'learn - facebook');
                  }
                }
              }
            );
            break;
        }
      },

      openShortcutsModal: function () {
        hotkeys.toggleCheatSheet();
      },

      showPreLearnModal: function () {
        var self = this;

        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'Prelearn Modal');
        }

        var bad_facts = $filter('filter')(self.currentFacts, {
          classification_id: '!',
          distractors: '!',
        });

        if (
          (!$rootScope.embed || (!self.currentCard.is_owned && !TokenService.values.tokens)) &&
          (bad_facts.length == 0 || self.currentCard.primary_tracks.length > 0)
        ) {
          self.switchModals(function () {
            self.preLearnVisible = true;
          });
        }
      },

      dismissPrelearnModal: function (dontRedeem) {
        var self = this;
        if ($rootScope.bodyClass.indexOf('prelearn-overlay-mobile-lock') !== -1) {
          $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('prelearn-overlay-mobile-lock'), 1);
        }
        return $q(function (resolve, reject) {
          if (self.currentCard.is_owned || dontRedeem) {
            self.preLearnVisible = false;

            resolve();
          } else {
            TokenService.redeem(self.currentCard.card_id).$promise.then(
              function () {
                self.preLearnVisible = false;
                self.currentCard.is_owned = 1;
                resolve();
              },
              function () {
                reject();
              }
            );
          }
        });
      },
      checkPostPreLearnModals: function () {
        var self = this;

        return $q(function (resolve) {
          if (!UserService.user.user_id || $rootScope.embed || $location.search().nomodal) {
            return resolve();
          }

          // Card Versioning Modal
          if (self.currentCard.seen_previous_version && !self.currentCard.versioning_modal_seen) {
            self.showCardVersionModal();

            // Safety Mode Modal
          } else if (self.currentCard.is_mature && !UserService.seen('safety_mode_modal')) {
            UserService.see('safety_mode_modal');
            self.showSafetyModeModal();
          }

          // If a modal was shown resolve the promise after the modal is closed
          if (self.modalInstance) {
            self.modalInstance.result.then(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      },

      switchModals: function (callback) {
        var self = this;

        if (self.modalInstance) {
          self.modalInstance.result.then(
            function () {
              callback();
            },
            function () {
              callback();
            }
          );
          self.closeModal();
        } else {
          callback();
        }
      },

      closeModal: function () {
        var self = this;

        if (self.modalInstance) {
          self.modalInstance.close();
          delete self.modalInstance;
        }
      },

      showCardVersionModal: function () {
        var self = this;
        return self.switchModals(function () {
          self.currentCard.versioning_modal_seen = 1;
          self.currentCard.$update();

          self.modalInstance = $modal.open({
            templateUrl: '/templates/modals/learn-card-version.html',
            windowClass: 'card-version-modal below-nav',
            backdropClass: 'below-nav',
            controller: [
              '$scope',
              '$modalInstance',
              'LearnService',
              function ($scope, $modalInstance, LearnService) {
                $scope.LearnService = LearnService;
                $scope.oldPicmonicSlug = self.currentCard.previous_version_card_id
                  ? self.currentCard.slug.split('_')[0] + '_' + self.currentCard.previous_version_card_id
                  : null;

                $scope.goToChangeLog = function () {
                  if (LearnService.fullscreen) {
                    LearnService.toggleFullscreen();
                  } else if (LearnService.theater) {
                    LearnService.toggleTheaterMode();
                  }
                  LearnService.visibleInfoSegments.changeLog = true;
                  $timeout(function () {
                    $('html, body').animate(
                      {
                        scrollTop: $('.learn-body-block--changelog').offset().top,
                      },
                      2000
                    );
                  });

                  $scope.close();
                };

                $scope.close = function () {
                  $modalInstance.close();
                };
              },
            ],
          });
        });
      },

      toggleSubtitles: function () {
        UserService.user.subtitles_enabled = UserService.user.subtitles_enabled ? 0 : 1;
        UserService.user.$update();
      },

      showUGCWarningModal: function () {
        var self = this;

        self.switchModals(function () {
          UserService.user.ugc_modal_seen = 1;
          UserService.user.$update();

          self.modalInstance = $modal.open({
            templateUrl: '/templates/modals/learn-ugc-disclaimer.html',
            windowClass: 'below-nav',
            backdropClass: 'below-nav',
            controller: [
              '$scope',
              function ($scope) {
                $scope.reportError = false;
                $scope.close = function () {
                  self.closeModal();
                };
              },
            ],
          });
        });
      },

      showReviewModal: function (defaultRating) {
        var self = this;

        self.switchModals(function () {
          self.modalInstance = $modal.open({
            templateUrl: '/templates/modals/picmonic-review.html',
            size: 'md',
            windowClass: 'rate-modal',
            controller: [
              '$scope',
              '$modalInstance',
              'Picmonics',
              'ReviewsConfig',
              'UserService',
              'XpService',
              function ($scope, $modalInstance, Picmonics, ReviewsConfig, UserService, XpService) {
                $scope.picmonic = angular.copy(self.currentCard);
                $scope.step = 1;
                $scope.tab = 'positive';
                $scope.UserService = UserService;

                $scope.review = {
                  rating: defaultRating
                    ? defaultRating
                    : $scope.picmonic.user_card_rating
                    ? $scope.picmonic.user_card_rating
                    : 0,
                };

                $scope.submitStep1 = function () {
                  if (!$scope.review.rating) {
                    $scope.error =
                      'Please provide a rating for this' +
                      ($scope.picmonic.entity_type_id == 1 ? ' Community' : '') +
                      ' Picmonic!';
                    return;
                  } else {
                    $scope.error = '';
                  }
                  if (!$scope.loading) {
                    $scope.loading = true;

                    $scope.review.resource = 'reviews';
                    $scope.review.card_id = $scope.picmonic.card_id;

                    Picmonics.save($scope.review, function (data) {
                      $scope.loading = false;

                      XpService.grant(
                        'PicmonicRating',
                        $scope.picmonic.card_id,
                        angular.element('.picmonic-rating-submit-button'),
                        'left: ' + (angular.element('.picmonic-rating-submit-button').width() / 2 + 36) + 'px;'
                      ).$promise.then(
                        function () {
                          $timeout(function () {
                            $scope.$close();
                          }, 1000);
                        },
                        function () {
                          $scope.$close();
                        }
                      );
                    });
                  }
                };

                $scope.setRating = function (rating) {
                  $scope.review.rating = rating;
                  $scope.tempRating = 0;
                  self.currentCard.user_card_rating = $scope.picmonic.user_card_rating = rating;
                };

                $scope.setTempRating = function (rating) {
                  $scope.tempRating = rating;
                };

                $scope.resetTempRating = function () {
                  $scope.tempRating = 0;
                };

                $scope.close = function () {
                  $modalInstance.close();
                };

                $modalInstance.result.then(
                  function () {
                    LearnService.modalInstance = null;
                  },
                  function () {
                    LearnService.modalInstance = null;
                  }
                );
              },
            ],
            backdrop: true,
          });
        });
      },

      showSafetyModeModal: function () {
        var self = this;

        self.switchModals(function () {
          self.modalInstance = SafetyModeModal.show();
        });
      },

      quizAnswer: function (answer) {
        var self = this;
        if (answer == 'y') {
          self.currentFact.last_answer = 1;
        } else if (answer == 'n') {
          self.currentFact.last_answer = 0;
        }
        if (!self.currentFact.fact_stats.num_attempts) {
          self.currentFact.fact_stats.num_attempts = 1;
        } else {
          self.currentFact.fact_stats.num_attempts++;
        }

        self.factsAttempted++;
        if (answer == 'y') {
          self.factsCorrect++;
        }
        self.currentFact.quizIncomplete = 0;
      },

      reset: function () {
        var self = this;
        angular.merge(self, defaults);

        self.closeModal();

        //Stop audio
        if (self.audioElement) {
          self.audioElement.pause();
          self.seek(0);
        }

        self.clearSelectedFact();
      },

      toggleFullscreen: function () {
        var self = this,
          calls,
          elem;

        if (self.fullscreen) {
          calls = [
            'cancelFullScreen',
            'exitFullscreen',
            'webkitExitFullscreen',
            'mozCancelFullScreen',
            'msExitFullscreen',
          ];
          elem = document;
        } else {
          calls = ['requestFullScreen', 'webkitRequestFullScreen', 'mozRequestFullScreen', 'msRequestFullscreen'];
          elem = angular.element('body')[0];
        }

        for (var i = 0; i < calls.length; i++) {
          if (elem[calls[i]]) {
            elem[calls[i]]();
            break;
          }
        }

        if (UserService.user.user_id) {
          UserService.user.$update();
        }
      },

      toggleTheaterMode: function () {
        var self = this;

        self.theater = self.theater === 1 ? 0 : 1;

        if (self.theater && self.fullscreen) {
          self.toggleFullscreen();
        }

        UserService.user.settings.learn_theater = self.theater;

        if (UserService.user.user_id) {
          UserService.user.$update();
        }
      },

      init: function (data) {
        var self = this;
        self.currentCard = data.currentCard;
        self.currentFacts = data.currentFacts;

        if (data.distractors) {
          self.distractors = data.distractors;
        }

        // Clipboard copy support
        self.copyUrl =
          $location.absUrl().replace('learn', 'share/picmonic') +
          '?utm_source=generic&utm_medium=social&utm_term=1463760192&utm_content=text_link&utm_campaign=player_share_link&' +
          UserService.getReferralParam();
        try {
          var visibleInfoSegments = angular.fromJson(window.localStorage.getItem('player_visible_segments'));
        } catch (e) {}

        if (visibleInfoSegments) {
          self.visibleInfoSegments = visibleInfoSegments;
        }
      },

      saveVisibleSegments: function () {
        try {
          window.localStorage.setItem('player_visible_segments', angular.toJson(this.visibleInfoSegments));
        } catch (e) {}
      },

      showSlowSpeedOnboarding: function () {
        this.show_slow_speed_onboarding = true;
      },

      hideSlowSpeedOnboarding: function () {
        this.show_slow_speed_onboarding = false;
        UserService.see('learn_slow_speed_onboarding');
      },

      initQuiz: function () {
        QuizService.init(
          'picmonic',
          this.currentCard.slug,
          {
            currentCard: angular.copy(this.currentCard),
            currentFacts: angular.copy(this.currentFacts),
          },
          {
            card_id: this.currentCard.card_id,
          },
          true
        );
      },

      loadCommunityFacts: function () {
        var self = this;
        if (!UserService.user.is_trial && UserService.user.user_id) {
          self.preloadNextPrevCard();

          Picmonics.query(
            {
              card_id: self.currentCard.card_id,
              resource: 'community_facts',
            },
            function (community_facts) {
              for (var a in community_facts) {
                forked_sum = 0;
                quality_sum = 0;
                for (var b in community_facts[a].facts) {
                  community_facts[a].facts[b].quality = 0;
                  if (community_facts[a].facts[b].characters && community_facts[a].facts[b].characters.length > 0) {
                    community_facts[a].facts[b].quality += 1000;
                  }
                  if (
                    community_facts[a].facts[b].picmonic &&
                    community_facts[a].facts[b].picmonic.toString().replace(/ /g, '').length > 0
                  ) {
                    community_facts[a].facts[b].quality += 100;
                  }
                  if (community_facts[a].facts[b].definition) {
                    community_facts[a].facts[b].quality += 10;
                    community_facts[a].facts[b].quality += community_facts[a].facts[b].definition.length / 100;
                  }
                  if (community_facts[a].facts[b].classification_id) {
                    community_facts[a].facts[b].quality += 1;
                  }

                  community_facts[a].facts[b].quality += community_facts[a].facts[b].forked * 20;

                  forked_sum += community_facts[a].facts[b].forked;
                  quality_sum += community_facts[a].facts[b].quality;
                }
                community_facts[a].forked = forked_sum;
                community_facts[a].quality = quality_sum;
              }

              self.communityFactGroups = community_facts;
            }
          );

          self.currentCommunityFact = {};
        }
      },

      showSafteyModeModal: function () {
        if (SafetyModeModal.check()) {
          SafetyModeModal.show();
        }
      },

      keyboard_shortcuts: [
        /** Toggle Audio Mode **/
        {
          keys: ['e', 's'],
          prelearn_description: 'Switch between Educational or Story audio modes',
          callback: function (key) {
            if (LearnService.mode === 'learn') {
              LearnService.setAudioModeAndPlay(key === 's' ? 'story' : 'educational');
            }
          },
        },

        /** Toggle Review Mode **/
        {
          keys: ['r'],
          prelearn_description: 'Toggle between Play and Review modes',
          callback: function () {
            if (LearnService.mode === 'learn') {
              LearnService.startReview();
            } else {
              LearnService.startLearn();
            }
          },
        },

        /** Toggle Fact Bar **/
        {
          keys: ['f'],
          prelearn_description: 'Show or hide the left fact bar',
          callback: function () {
            if (LearnService.mode === 'learn') {
              LearnService.toggleFactBar();
            }
          },
        },

        /** Toggle Definition **/
        {
          keys: ['d'],
          prelearn_description: 'Toggle the fact definition',
          callback: function () {
            if (LearnService.mode === 'learn') {
              LearnService.toggleDefinitionVisibility();
            }
          },
        },

        /** Change Audio Speed **/
        {
          keys: ['=', '-'],
          prelearn_description: 'Adjust the player audio speed',
          labels: {
            '=': '+',
          },
          callback: function (key) {
            var new_audio_speed;
            if (key == '=') {
              new_audio_speed = UserService.user.audio_speed + 0.25;
            } else {
              new_audio_speed = UserService.user.audio_speed - 0.25;
            }
            new_audio_speed = new_audio_speed > 2 ? 2 : new_audio_speed < 0.75 ? 0.75 : new_audio_speed;
            if (LearnService.audioElement) {
              LearnService.audioElement.playbackRate = new_audio_speed;
            }
            UserService.user.audio_speed = new_audio_speed;
            if (LearnService.userUpdateTimeout !== false) {
              window.clearTimeout(LearnService.userUpdateTimeout);
            }
            LearnService.userUpdateTimeout = window.setTimeout(function () {
              if (UserService.user.user_id) {
                UserService.user.$update();
              }
            }, 1000);
          },
        },

        /** Navigate Picmonics **/
        {
          keys: [',', '.'],
          icons: {
            ',': 'keyboard_arrow_left',
            '.': 'keyboard_arrow_right',
          },
          prelearn_description: 'Switch between Picmonics in a Playlist using the less than and greater than keys',
          callback: function (key) {
            if (key == ',') {
              PicmonicQueue.previous();
            } else {
              PicmonicQueue.next();
            }
          },
        },

        /** Navigate Facts **/
        {
          keys: ['up', 'down'],
          icons: {
            up: 'keyboard_arrow_up',
            down: 'keyboard_arrow_down',
          },
          prelearn_description: 'Move up and down between the facts using the up & down arrow keys',
          callback: function (key, event) {
            event.preventDefault();
            if (
              !LearnService.currentCommunityFact.fact_id &&
              (LearnService.mode != 'quiz' || (LearnService.mode == 'quiz' && !LearnService.quiz_mode))
            ) {
              if (key == 'down') {
                LearnService.nextFactStep();
              } else {
                LearnService.previousFact();
              }
              if (
                LearnService.currentFact.fact_id &&
                LearnService.currentFact.entity_type_id == 2 &&
                LearnService.currentFact.audio &&
                LearnService.currentFact.audio[LearnService.audioMode]
              ) {
                LearnService.seek(LearnService.currentFact.audio[LearnService.audioMode].start);
              } else {
                if (LearnService.audioElement) {
                  LearnService.audioElement.pause();
                }
              }
            } else if (LearnService.currentCommunityFact.fact_id) {
              var allFacts = [];
              angular.forEach(
                $filter('orderBy')(
                  $filter('filter')(LearnService.communityFactGroups, {
                    is_hidden: '!1',
                  }),
                  ['-forked', '-quality']
                ),
                function (value, key) {
                  angular.forEach(
                    $filter('limitTo')(
                      $filter('orderBy')(
                        $filter('filter')(value.facts, {
                          is_added: '!1',
                          is_hidden: '!1',
                        }),
                        ['-forked', '-quality']
                      ),
                      10
                    ),
                    function (value_two, key_two) {
                      allFacts.push(value_two);
                    }
                  );
                }
              );

              var factpos = $filter('arrayPos')(allFacts, LearnService.currentCommunityFact.fact_id, 'fact_id');
              if (key == 'down' && factpos == allFacts.length - 1) {
                factpos = -1;
              } else if (key == 'up' && factpos == 0) {
                factpos = allFacts.length;
              }

              var fact;
              if (key == 'down') {
                fact = allFacts[factpos + 1];
              } else {
                fact = allFacts[factpos - 1];
              }

              angular.forEach(LearnService.communityFactGroups, function (value, key) {
                value.open = false;
                angular.forEach(value.facts, function (value_two, key_two) {
                  value_two.selected = false;

                  if (value_two == fact) {
                    value_two.selected = true;

                    value.open = true;
                    LearnService.currentCommunityFact = fact;
                  }
                });
              });
            }
          },
        },

        /** Play & Pause Audio **/
        {
          keys: ['space'],
          prelearn_description: 'Play and pause the player audio',
          callback: function (key, e) {
            if (LearnService.mode == 'learn' && LearnService.currentCard.audio.educational) {
              e.preventDefault();
              LearnService.playPauseAudio();
            }
          },
        },
      ],
      randomShortcut: function () {
        var shortcuts = $filter('filter')(LearnService.keyboard_shortcuts, {
          prelearn_description: '',
        });
        return shortcuts[Math.round(Math.random() * (shortcuts.length - 1))];
      },
    };

    LearnService.reset();

    document.addEventListener('webkitfullscreenchange', exitHandler, false);
    document.addEventListener('mozfullscreenchange', exitHandler, false);
    document.addEventListener('fullscreenchange', exitHandler, false);
    document.addEventListener('MSFullscreenChange', exitHandler, false);

    function exitHandler() {
      if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement) {
        $rootScope.$apply(function () {
          LearnService.fullscreen = true;
        });
      } else {
        $rootScope.$apply(function () {
          LearnService.fullscreen = false;
        });
      }
    }

    QuizService.LearnService = LearnService;

    return LearnService;
  },
]);
